/**
 * Blueprint for the merge address object.
 */
export class MergeAddress {
  public street: string;
  public city: string;
  public postalCode: string;

  constructor(data: any) {
    this.street = data?.street;
    this.city = data?.city;
    this.postalCode = data?.postalCode;
  }
}
